import { v4 as uuid } from "uuid";
import { useState } from "react";
import FormInputError from "components/General/FormInputError";

export default function MessageBox({
  labelName,
  containerClassName,
  register,
  name,
  validationsProps,
  validationMessage,
  maximumWordCount,
  startingWordCount = 0,
  textAlign,
  rows = "4",
  setIsMessageFill,
}) {
  const UUID = uuid();
  const [currentWordCount, setCurrentWordCount] = useState(startingWordCount);

  return (
    <div className={containerClassName}>
      <label id={`${UUID}-${name}-label`}>{labelName}</label>
      <textarea
        id={`${UUID}-${name}`}
        type="text"
        name={name}
        aria-labelledby={`${UUID}-${name}-label`}
        className="mt-1"
        rows={rows}
        {...register(name, {
          ...validationsProps,
          onChange: (e) => {
            setCurrentWordCount(e.target.value.length);
            setIsMessageFill(e.target.value ? true : false);
          },
        })}
      />
      <p
        className={`${
          currentWordCount > maximumWordCount ? "text-red-600" : "text-sm "
        } ${textAlign}`}
      >
        ({currentWordCount}/{maximumWordCount})
      </p>

      {validationMessage && <FormInputError errorMessage={validationMessage} />}
    </div>
  );
}
